exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon.is-clickable[data-v-dfca0f44]{pointer-events:auto;cursor:pointer}.icon.is-clickable[data-v-dfca0f44]:hover{color:#b5b5b5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dfca0f44","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/views/users/index/components/NameField.vue
// module id = 2m0I
// module chunks = 1